// extracted by mini-css-extract-plugin
export default {"main_container":"ButtonArrowForward_main_container__IMttg","arrow":"ButtonArrowForward_arrow__+ta7C","clickable":"ButtonArrowForward_clickable__oWcFt"};